import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import thunk from 'redux-thunk';
import {apiRedux} from "./apiRedux";
import auth from "./auth";
import toggleSidebar from "./toggleSidebar";
import filtersReducer from "./../Slices/filterSlice";

const rootReducer = {
  auth,
  toggleSidebar,
  [apiRedux.reducerPath]: apiRedux.reducer,
  filters: filtersReducer,
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiRedux.middleware)
      .concat(thunk),

  preloadedState: {},

})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export default store
